<template>
  <div v-if="currentStep == item.step && hideOption(item) && showRfeCaseOption" v-show="item.showMe">
    <div
      class="title_block"
      :class="{ 'pb-6-- mb-2---': item.code == requestLCA.indexOf(item.code) > -1 }"
    >
      <label :code="item.code" class="form_label">{{ item.name }}</label>
      <div class="table_switch">
        <div v-if="item.optional" class="switch_tooltip">
          <span>Switch-off/on to make this step optional/required</span>
        </div>
        
        <vs-switch
          success
          v-model="item.actionRequired"
          :name="'actionRequired' + currentIndex"
          @input="resetValidater()"
          :disabled="checkdisable(item)"
        >
          <template #off>
            <x-icon size="1.5x" class="custom-class"></x-icon>
          </template>
          <template #on>
            <check-icon size="1.5x" class="custom-class"></check-icon>
          </template>
        </vs-switch>
      </div>
    </div>
    <div class="vx-row" v-if="hideEditorswatchers.indexOf(item.code) < 0">
     
      <div
        class="vx-col md:w-1/2 w-full"
        v-if="hideEditors.indexOf(item.code) < 0"
      >
       <div class="form_group">
          <div class="con-select w-full">
            <multiselect
              :hide-on-select="true"
              name="Editors"
              :limitText="limitText"
              v-model="item.editors"
              :close-on-select="false"
              :disabled="(disableEditors.indexOf(item.code) > -1 || item.actionRequired==false )
              "
              :multiple="true" :hideSelected="true"
              :show-labels="false"
              :ref="'Editors' + currentIndex"
             
              track-by="uniqueId"
              label="roleName"
              data-vv-as="Editors"
              placeholder="Select"
              :options="userRolesListEditors"
              @input="resetValidater()"
              :searchable="true"
              :allow-empty="true"
            >
              <template
                slot="selection"
                slot-scope="{ values, remove  }"
              >
                <span class="multiselect__tags_default" v-if="values.length">
                  <div class="multiselect__tags-wrap">
                    <span class="multiselect__tag">
                      <span>
                        {{ values[0].roleName }}
                      </span>
                      <i @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                    </span>
                  </div>
                  <strong v-if="values.length > 1" class="multiselect__strong">
                    + {{ values.length-1 }}
                  </strong>
                </span></template
              >
            </multiselect>
           <p style="display: none;"> {{ item.showError }}</p>
            <span class="text-danger text-sm" v-if="item.showError"
              >Editors are required</span
            >
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="form_group flex_group"  v-if="hideWatchers.indexOf(item.code) < 0">
          <label class="form-label d-flex">Notify<p>
                                    <vs-icon  icon="information" size="small" ></vs-icon>
                                    <small>Every action will be sent as an email notification to the assigned user of these roles.</small>
                                </p></label>
          <div class="con-select">
            <multiselect
              :hide-on-select="true"
              name="watchers"
              :hideSelected="true"
              v-model="item.watchers"
              :close-on-select="false"
              :multiple="true" 
              :limitText="limitText"
              :show-labels="false"
              :ref="'watchers' + currentIndex"
              track-by="uniqueId"
              label="roleName"
              data-vv-as="watchers"
              placeholder="Select"
              :options="userRolesList"
              :searchable="true"
              :allow-empty="true"
              :disabled="!item.actionRequired"
            >
           <template
                slot="selection"
                slot-scope="{ values, remove  }"
              >
                <span class="multiselect__tags_default" v-if="values.length">
                  <div class="multiselect__tags-wrap">
                    <span class="multiselect__tag">
                      <span>
                        {{ values[0].roleName }}
                      </span>
                      <i @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                    </span>
                  </div>
                  <strong v-if="values.length > 1"  class="multiselect__strong">
                    + {{ values.length-1 }}
                  </strong>
                </span></template
              >
            </multiselect>
          </div>
        </div>
      </div>
    </div>

      <div class="vx-row" v-if="workflowDetails.workflowType =='Free-Flow' && ['SUPERVISOR_LIST','ASSIGN_PARALEGAL','PARALEGAL_LIST','ASSIGN_DOCUMENTATION_MANAGER','DOCUMENTATION_MANAGER_LIST','ASSIGN_DOCUMENTATION_EXECUTIVE','DOCUMENTATION_EXECUTIVE_LIST'].indexOf(item.code) > -1">
      <div class="vx-col md:w-1/2 w-full" style="padding-bottom:20px;margin-top:-5px;">

        <div class="form_group flex_group">
          <label class="form-label d-flex  align-center"> 

            <vs-checkbox :disabled="!checkProperty(item,'actionRequired')" name="confirmRequiredVal" 	 v-model="item.confirmRequiredVal" class="w-full" >
              Confirmation Required
            </vs-checkbox>
            <p>
              <vs-icon  icon="information" size="small" class="mb-4"></vs-icon>
              <small>This option is used to confirm that assigned user has completed his/her job</small>
            </p>
        </label>
        </div>
      </div>
      </div>

   <div class="vx-row" v-if="workflowDetails.workflowType =='Free-Flow' && item.code=='ASSIGN_SUPERVISOR'">
      <div class="vx-col md:w-1/2 w-full">
         <div class="form_group flex_group">
          <label class="form-label d-flex  align-center"> 
            <vs-checkbox :disabled="checkProperty(workflowDetails, 'tplTypeId')==5" name="canAssignAllUsersVal" 	 v-model="item.canAssignAllUsersVal" class="w-full" >
              Can assign all users at once.        
            </vs-checkbox>
            <p>
              <vs-icon  icon="information" size="small" class="mb-4"></vs-icon>
              <small>By enabling this option allows you to assign all users parallelly</small>
            </p>
          </label>
         </div>
      </div>
      </div>

      <div class="vx-row" v-if="item.code=='COLLECT_ADV_EVIDENCE'">
        <div class="vx-col w-full" style="padding-bottom:20px;margin-top:-5px;">
          <vs-checkbox name="approvedPwdReqForAdvEvidences" @change="updateCollectionAdvEvd"	 v-model="item.approvedPwdReqForAdvEvidencesBol" class="w-full" >
            PWD Approval Required for collecting advertisement.
            
            
            </vs-checkbox>
        </div>
      
      </div>

      <div class="vx-row" v-if="item.code=='PREPARE_PERM_APPLICATION'">
      
      <div class="vx-col w-full" style="padding-bottom:20px;margin-top:-5px;">
        <vs-checkbox name="restrictPermDraftByAdvConfig" @change="updaterestrictPermDraftByAdvConfig"	 v-model="item.restrictPermDraftByAdvConfigBol" class="w-full" >
          Allow PERM creation after the cooling period from the date of last advertisement. 
           
          
          
          </vs-checkbox>
      </div>
      </div>
      <div  class="vx-row" v-if="checkProperty(workflowDetails ,'tplTypeId')==1 && item.code=='UPDATE_USCIS_RESPONSE'" >
        <div class="vx-col w-full">
          <div class="form_group">
              <div class="custom-radio_wrap wf_radio">
            
            <label class="form_label form_wf_label">How do you want to handle RFE case?</label>
                  <ul class="custom-radio mt-3 ml-0">
                    <li>
                        <vs-radio    name="manageRfeCase" @input="manageRfeCaseAction('with_in_case')"  vs-value="with_in_case"   v-model="item.manageRfeCase" class="w-full"
                        >With in Case</vs-radio> 
                    </li>
                    <li>
                      <vs-radio    name="manageRfeCase" @input="manageRfeCaseAction('filed_separately')"  vs-value="filed_separately" v-model="item.manageRfeCase" class="w-full"
                        >File Separately</vs-radio> 
                    </li>
                    
                  </ul>
                </div>
          </div>  
        </div>
      </div>

      

  </div>
</template>

<script>
import * as _ from "lodash";
import { CheckIcon } from "vue-feather-icons";
import { XIcon } from "vue-feather-icons";

export default {
  computed:{
    showRfeCaseOption(){
      /*
       '$store.state.manageRfeCase':function(val){
        if(val =='with_in_case'){
        }else{ 
        }
      }
       */
      let returnVal = true;
      let manageRfeCase = this.$store.state.manageRfeCase
      if( ['RFE_DOC_SIGNER_LIST','RFE_PREPARE_RESPONSE_DOCS','RFE_CASE_APPROVED','RFE_REQUEST_PETITIONER_SIGN','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER','RFE_UPDATE_USCIS_RESPONSE'].indexOf(this.item.code) >-1  && ['with_in_case','filed_separately'].indexOf(manageRfeCase)>-1 ){
        if(manageRfeCase =='with_in_case'){
          returnVal = true;
        }else{
          returnVal = false;
        }
      }
      return returnVal;
    }
  },
  data: () => ({
  
    hideEditors: [
      "CREATE_PETITION",
      "SUBMIT_BY_BENEFICIARY",
      "SUBMIT_TO_LAW_FIRM",
      'FILE_AFTER_INVOICE_PAYMENT'
    ],
    hideWatchers:["MANAGER_LIST"],
    hideEditorswatchers: [ "PAYMENT_INTEGRATION","FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"],
    requestLCA: ["LCA_REQUEST"],
    submitLCA: ["LCA_SUBMIT"],
    
    disableEditors: ["CREATE_PETITION","SUBMIT_BY_BENEFICIARY","SUBMIT_TO_LAW_FIRM"]
  }),
  props: {
    workflowDetails:{
     type: Object,
     default:null
  },
  tenantDetails:{
     type: Object,
     default:null
  },
    currentStep: {
      type: Number,
    },
    userRolesList: {
      type: Array,
    },
    userRolesListEditors: {
      type: Array,
    },
    item: {
      type: Object,
    },
    currentIndex: {
      type: Number,
    },
    activityList: {
      type: Array,
    },
  },
  methods: {
    manageRfeCaseAction(val){
      this.$store.commit('updateManageRfeCase',val)
      //this.$emit('manageRfeCaseAction');
    },
    updaterestrictPermDraftByAdvConfig(){
     
    if( this.item.code === 'PREPARE_PERM_APPLICATION' && this.item.restrictPermDraftByAdvConfigBol == true){
        this.item.restrictPermDraftByAdvConfig = 'Yes';
    }else if( this.item.code === 'PREPARE_PERM_APPLICATION' && this.item.restrictPermDraftByAdvConfigBol !=true ){
        this.item.restrictPermDraftByAdvConfig = 'No';
    }
   

    },
    updateCollectionAdvEvd(){
     
     if( this.item.code === 'COLLECT_ADV_EVIDENCE' && this.item.approvedPwdReqForAdvEvidencesBol == true){
         this.item.approvedPwdReqForAdvEvidences = 'Yes';
     }else if( this.item.code === 'COLLECT_ADV_EVIDENCE' && this.item.approvedPwdReqForAdvEvidencesBol !=true ){
         this.item.approvedPwdReqForAdvEvidences = 'No';
     }
    
 
     },
    limitText(count) {
      return "+" + count;
    },
    resetValidater() {
    
      //checkProperty(item,'actionRequired')" name="confirmRequiredVal" 	 v-model="item.confirmRequiredVal"
      if(!this.checkProperty(this.item,'actionRequired') && _.has( this.item,'confirmRequiredVal')){
         
        this.item.confirmRequiredVal = false;
      }

      
      if(this.item.actionRequired){
        this.item['include'] =true;
        this.item['include'] =false;
      }else{
        this.item['include'] =false;
        this.item['actionRequired'] =false;
      }
      this.item.showError = false;
        if(this.checkProperty(this.item ,'code') =="LCA_REQUEST"){
            this.hideEditorswatchers= [ "PAYMENT_INTEGRATION" ,"FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"]
            if(this.getTenantTypeId ==2 || this.checkProperty(this.tenantDetails ,'typeId')==2){
                 this.hideEditorswatchers= [ "PAYMENT_INTEGRATION","FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"]
                  if(!this.item.actionRequired){
                    this.hideEditorswatchers= [ "PAYMENT_INTEGRATION" ,"FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"]
                  }

              }else{
                //assign default editors for LCA_REQUEST
                // this.item.editors = [{  "roleId":50, "roleName":"Petitioner"  }]


              }
        }
        if(this.checkProperty(this.item ,'code') =="FILING_FEE" ){
          
          _.map(this.activityList ,(activity)=>{
            if(['FILE_AFTER_INVOICE','FILE_AFTER_INVOICE_PAYMENT'].indexOf(this.checkProperty(activity ,'code')) >-1){
              activity['actionRequired'] =false;
              activity['include'] =false;
              if(this.checkProperty(this.item ,'actionRequired')){
                activity.optional =true;
              }else{
                activity.optional =false;
              }
             
            }

          })
        }

       // validate DOCUMENTATION_EXECUTIVE_LIST;
       if(this.checkProperty(this.item ,'code') =='DOCUMENTATION_EXECUTIVE_LIST'){
  
                  if(!this.item.actionRequired){
                  _.forEach(this.activityList ,(activity)=>{

                    if(activity['code']=='ASSIGN_DOCUMENTATION_EXECUTIVE'){
                      activity['actionRequired'] =false;
                      activity['include'] =false;
                    }
                    if(activity['code']=='DOCUMENTATION_EXECUTIVE_LIST'){
                      activity['actionRequired'] =false;
                      activity['include'] =false;
                      activity['editors'] =[];
                      
                      //activity['showMe'] =false
                    }

                  })
                }else{
                  _.forEach(this.activityList ,(activity)=>{

                    
                    if(activity['code']=='DOCUMENTATION_EXECUTIVE_LIST'){
                      activity['showMe'] =true;
                    }

                    // if(activity['code']=='ASSIGN_DOCUMENTATION_EXECUTIVE'){
                    //   activity['actionRequired'] =true;
                    // }

                  })

          }     

        }
        if(this.checkProperty(this.item ,'code') =='DOCUMENTATION_MANAGER_LIST'){
  
           if(!this.item.actionRequired){
            _.forEach(this.activityList ,(activity)=>{

              if(activity['code']=='ASSIGN_DOCUMENTATION_MANAGER'){
                activity['actionRequired'] =false;
                activity['include'] =false;
              }
              if(activity['code']=='ASSIGN_DOCUMENTATION_EXECUTIVE'){
                activity['actionRequired'] =false;
                activity['include'] =false;
              }
              if(activity['code']=='DOCUMENTATION_EXECUTIVE_LIST'){
                activity['actionRequired'] =false;
                activity['include'] =false;
                activity['editors'] =[];
                activity['showMe'] =false
              }

            })
          }else{
            _.forEach(this.activityList ,(activity)=>{

              if(activity['code']=='ASSIGN_DOCUMENTATION_MANAGER'){
                activity['actionRequired'] =true;
                activity['include'] =true;
              }
              if(activity['code']=='DOCUMENTATION_EXECUTIVE_LIST'){
                activity['showMe'] =true;
              }

              // if(activity['code']=='ASSIGN_DOCUMENTATION_EXECUTIVE'){
              //   activity['actionRequired'] =true;
              // }

            })

          }

        }
        if(this.checkProperty(this.item ,'code') =='ASSIGN_SUPERVISOR'){
          this.item.actionRequired = true;
          this.item.include = true;
          this.item.confirmRequiredVal=false;
          this.item.confirmRequiredVal=false;
          this.item.confirmRequired= 'No';
          this.item.confirmRequired= 'No';
        }else if(!this.item.actionRequired ){
          this.item['editors'] =[];
          this.item['watchers'] =[];
          
        }

        if(this.checkProperty(this.item ,'code') =='PARALEGAL_LIST'){
  
          if(!this.item.actionRequired){
            _.forEach(this.activityList ,(activity)=>{

              if(activity['code']=='ASSIGN_PARALEGAL'){
                activity['actionRequired'] =false;
                activity['include'] =false;
              }
              
              

            })
          }else{
            _.forEach(this.activityList ,(activity)=>{

              if(activity['code']=='ASSIGN_PARALEGAL'){
                  activity['actionRequired'] =true;
                  activity['include'] =true;
              }


            })

          }
        
      }

      if(this.checkProperty(this.item ,'code') =='ATTORNEY_LIST'){
  
        if(!this.item.actionRequired){
          _.forEach(this.activityList ,(activity)=>{

            if(activity['code']=='ASSIGN_ATTORNEY'){
              activity['actionRequired'] =false;
              activity['include'] =false;
            }
            
            

          })
        }else{
          _.forEach(this.activityList ,(activity)=>{

            if(activity['code']=='ASSIGN_ATTORNEY'){
                activity['actionRequired'] =true;
                activity['include'] =true;
            }


          })

        }

    }
 
    if( this.getTenantTypeId==2){
      if(this.checkProperty(this.item ,'code') =='FILE_AFTER_INVOICE_PAYMENT' ){
          //alert(this.getTenantTypeId)
          this.item['include'] =false;
          this.item['actionRequired'] =false;
          this.item['showMe'] =false;
      }
      
      if(this.checkProperty(this.item ,'code') =='SUBMIT_TO_LAW_FIRM' ){
         this.item['showMe'] =false;
      }
    }

      
    },
    hideOption(item) {
      

      if(['RFE_PREPARE_RESPONSE_DOCS','RFE_REVIEW_RESPONSE_DOCS','REF_CASE_APPROVED','RFE_REQUEST_PETITIONER_SIGN','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER','RFE_UPDATE_USCIS_RESPONSE'].indexOf(this.checkProperty(item, 'code'))>-1 ){ 
        //let finalStatusUpdateActivity = _.find(this.activityList, {"code":'UPDATE_USCIS_RESPONSE'});
        //$store.state.manageRfeCase ['with_in_case','filed_separately'].indexOf( this.checkProperty(finalStatusUpdateActivity, 'manageRfeCase'))>-1
          if(this.checkProperty( this.$store,'state','manageRfeCase') &&  ['with_in_case','filed_separately'].indexOf(this.checkProperty( this.$store,'state','manageRfeCase' ))>-1){
            let val = this.checkProperty( this.$store,'state','manageRfeCase' );
            if(val=='with_in_case'){
                    this.item.include = true;
                    this.item.showMe= true
                    this.item.actionRequired =true;
                    this.item.optional =true;
                    if(['RFE_PREPARE_RESPONSE_DOCS','RFE_REVIEW_RESPONSE_DOCS','REF_CASE_APPROVED','RFE_SUBMIT_TO_USCIS','RFE_COURIER_TRACKING','RFE_UPDATE_USCIS_RECEIPT_NUMBER','RFE_UPDATE_USCIS_RESPONSE'].indexOf(this.checkProperty(item, 'code'))>-1 ){ 
                      this.item.optional =false
                    }
                    return true;
                    //this.item.optional =false
                  }else if(val=='filed_separately'){
                   
                    this.item.include = false;
                    this.item.showMe= false;
                    this.item.actionRequired =false;
                    this.item.editors =[];
                    this.item.watchers =[];
                    return false;
                  
                  }

          }
      }
    
    if(['FILING_FEE' ,'PAYMENT_INTEGRATION',"FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"].indexOf(item.code)>-1){
        if(this.getTenantTypeId ==2 || this.checkProperty(this.tenantDetails ,'typeId')==2){
          item["include"] =false
          item["actionRequired"] = false;
          return false
        }
      }


      if(['DOC_SIGNER_LIST'].indexOf(item.code)>-1){
        if(this.getTenantTypeId !=2 && (this.checkProperty(this.tenantDetails ,'typeId')!=2  )){
          return false
        }
      }
     
      
     
      if (this.submitLCA.indexOf(item.code) > -1 ) {
      
        var _findlcaRequest = _.find(this.activityList, {
          code: "LCA_REQUEST",
        });
        if (!_findlcaRequest.actionRequired) {
       
          return false;
        }
      }
      return true;  
    },
    checkdisable(item) {

      //item.canAssignAllUsers= 'Yes'
      if(this.checkProperty(this.workflowDetails, 'tplTypeId')==5 && this.item.code=='ASSIGN_SUPERVISOR'){

       ///workflowDetails.workflowType =='Free-Flow' && item.code=='ASSIGN_SUPERVISOR'
        this.item.canAssignAllUsers= 'Yes'
      }
      if(['RFE_REQUEST_PETITIONER_SIGN','RFE_CASE_APPROVED'].indexOf(item.code) >-1 ){
            item['optional'] = true;
      }
      if (!item.optional ) {
        return true;
      }
      if(this.item.code === 'LCA_REQUEST' && [8,9].indexOf(this.checkProperty(this.workflowDetails, 'tplTypeId'))>-1){
        return true;
      }
    },
  },
  components: {
    CheckIcon,
    XIcon,
  },
    watch: {

      

    //   'item.manageRfeCase'(val) {

    //     this.manageRfeCaseAction();
       
    // },

    'item.canAssignAllUsersVal'(val) {
      if(val){
        this.item.canAssignAllUsers= 'Yes'
    }else{
      this.item.canAssignAllUsers= 'No'
    }
    },
    'item.confirmRequiredVal'(val) {
      if(val){
        this.item.confirmRequired= 'Yes'
    }else{
      this.item.confirmRequired= 'No'
    }
    }
  },
  mounted(){

   

       if(this.item.canAssignAllUsersVal == true){
      this.item.canAssignAllUsers= 'Yes'
    }
    
       if(this.item.canAssignAllUsersVal == false){

      this.item.canAssignAllUsers= 'No'
    }

    if(this.item.confirmRequired == 'Yes'){
     
      this.item.confirmRequiredVal = true
    }
    if(this.item.confirmRequired == 'No'){
      this.item.confirmRequiredVal = false
    }
       
    
     this.hideEditors = [  "CREATE_PETITION",   "SUBMIT_BY_BENEFICIARY", "SUBMIT_TO_LAW_FIRM"];
     this.disableEditors =  ["CREATE_PETITION","SUBMIT_BY_BENEFICIARY","SUBMIT_TO_LAW_FIRM"];
     this.hideEditorswatchers= [ "PAYMENT_INTEGRATION","FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"]
    if(this.getTenantTypeId ==2 || this.checkProperty(this.tenantDetails ,'typeId')==2){
        this.hideEditors = [  "CREATE_PETITION",   "SUBMIT_BY_BENEFICIARY"]
      this.disableEditors =  ["CREATE_PETITION","SUBMIT_BY_BENEFICIARY"];
       this.hideEditorswatchers= [ "PAYMENT_INTEGRATION","FILE_AFTER_PAYMENT","FILE_AFTER_INVOICE"]



    }
    //'FILE_AFTER_INVOICE','FILE_AFTER_INVOICE_PAYMENT'
    this.hideEditors.push('FILE_AFTER_INVOICE');
    this.hideEditors.push('FILE_AFTER_INVOICE_PAYMENT');
    this.hideEditorswatchers.push('FILE_AFTER_INVOICE_PAYMENT');
    this.hideEditorswatchers.push('FILE_AFTER_INVOICE');

    if( this.item.code === 'COLLECT_ADV_EVIDENCE' && this.item.approvedPwdReqForAdvEvidences === 'Yes'){
       
       this.item.approvedPwdReqForAdvEvidencesBol=true;
   }else if( this.item.code === 'COLLECT_ADV_EVIDENCE' && !this.item.approvedPwdReqForAdvEvidences === 'Yes'){
     this.item.approvedPwdReqForAdvEvidencesBol = false;
   }

   if( this.item.code === 'PREPARE_PERM_APPLICATION' && this.item.restrictPermDraftByAdvConfig === 'Yes'){
       
       this.item.restrictPermDraftByAdvConfigBol=true;
   }else if( this.item.code === 'PREPARE_PERM_APPLICATION' && !this.item.restrictPermDraftByAdvConfig === 'Yes'){
     this.item.restrictPermDraftByAdvConfigBol = false;
   }

   //
    
    //'FILE_AFTER_INVOICE_PAYMENT'
    this.resetValidater();
  }
};
</script>